export default function findPropertyValue(propertyName, properties, convertToString = true) {
  let value
  if (Array.isArray(properties)) {
    const foundProperty = properties.find((prop) => {
      return prop.name === propertyName
    })
    value = convertToString ? foundProperty?.values.join(', ') : foundProperty?.values
  }
  return value || (convertToString ? '' : [])
}
